module.exports = __webpack_public_path__ + "img/exhibit.f9bcb8db.svg";